import { withViewData } from "../../App/ViewData"
import { ShipDataUsersViewProps } from "./Params"
import { UsersDataView } from "./UsersDataView"
import { UsersViewUI } from "./UsersViewUI"

// `UsersDataView` is the `useDeps`/store crew data-acquisition layer: it builds the
// `ShipUsersData` and provides it via `ShipUsersDataContext`, so the presentational
// `UsersViewUI` never touches acquisition. Exported as `ShipDataUsersView` -- the name
// `ShipDataView` imports for the ship_users tab. (issue #1186)
export const ShipDataUsersView = withViewData<ShipDataUsersViewProps>({
  acquire: UsersDataView,
  ui: UsersViewUI,
});
